module.exports = __webpack_public_path__ + "img/drupal7.e66f8235.png";